/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  var params = new URLSearchParams(window.location.search);
  if (params.get("notify") !== "back-in-stock") {
    checkCountry();
  }
  
  if (document.getElementsByClassName("slideshow-landing-container-custom")) {
    for (let i = 0; i < document.getElementsByClassName("slideshow-landing-container-custom").length; i++) {
      resizeImageLanding(document.getElementsByClassName("slideshow-landing-container-custom")[i].id);  
    }
  }

  if (document.getElementsByClassName("slideshow-home-container-custom")) {
    for (let i = 0; i < document.getElementsByClassName("slideshow-home-container-custom").length; i++) {
      resizeImageHome(document.getElementsByClassName("slideshow-home-container-custom")[i].id);  
    }
  }

  if (document.getElementsByClassName("home-carousel-container-custom")) {
    for (let i = 0; i < document.getElementsByClassName("home-carousel-container-custom").length; i++) {
      resizeHomeCarousel(document.getElementsByClassName("home-carousel-container-custom")[i].id);  
    }
  }

  if (document.getElementsByClassName("images-row-custom-carousel")) {
    for (let i = 0; i < document.getElementsByClassName("images-row-custom-carousel").length; i++) {
      resizeImagesRow(document.getElementsByClassName("images-row-custom-carousel")[i].id);  
    }
  }
  
  if (document.getElementsByClassName("fullwidth-header")[0]) {
	  resizeImageHeader();  
  }
  
  if (document.getElementsByClassName("mosaic-custom")[0]) {
	  resizeImageMosaic();  
  }

  if (document.getElementsByClassName("promo-custom")[0]) {
	  resizeImagePromo();  
  }
  
  if (document.getElementById("athlete")) {
    setTimeout(() => {
      document.getElementById("athlete").style.display = "none";
    }, "500")
  }

  showSlides(1);  
  
  /*
  if (document.getElementsByClassName("bundle-product-container").length > 0) {
    checkSelectedProducts();
  }
  */

  /*
  if (window.location.pathname == '/') {
    showSnowmen();
  }
  */
   
  if (document.getElementsByClassName("featured_product_reviews").length > 0) {
    showReviews();
  }
  
  if (document.getElementById("giftProductsInCart")) {
    checkCartItems();
  }

  if (document.getElementById("blog-discount-popup-container")) {
    showPopup();
  }
});

/* Reload the header on back, because cart quantity number is not updated */
window.addEventListener('pageshow', function ( event ) {
  if (event.persisted || performance.getEntriesByType("navigation")[0].type === 'back_forward') {
    $( ".header__cart-icon" ).load(window.location.href + " .header__cart-icon>*","" );
  }
});

let slideIndex = 1;
  
function plusSlides(n) {
  showSlides(slideIndex += n);
}

function currentSlide(n) {
  showSlides(slideIndex = n);
}

function showSlides(n) {
  if (document.getElementsByClassName("mySlides")) {
    let i;
    let slides = document.getElementsByClassName("mySlides");
    let dots = document.getElementsByClassName("dot");

    if (dots.length === 0) {dots = document.getElementsByClassName("thumb-image");}
    if (n > slides.length) {slideIndex = 1}    
    if (n < 1) {slideIndex = slides.length}
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";  
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
    }
    if (slides[slideIndex-1]) {
      slides[slideIndex-1].style.display = "block";  
    }
    if (dots[slideIndex-1]) {
      dots[slideIndex-1].className += " active";
    }
  }
}

function scrollToSection(sectionId) {
  var element = document.getElementById(sectionId);
  var headerOffset = 150;
  var elementPosition = element.getBoundingClientRect().top;
  var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
}

function hide_title() {
  document.getElementsByClassName("spr-header-title")[0].innerHTML = "";
}


/***********************************************************/
/*--- FUNCTION FOR CHECKING SELECTED PRODUCTS IN BUNDLE ---*/
/***********************************************************/

function checkSelectedProducts() {
  const bundleProducts = document.querySelectorAll('[data-product-bundle="bundle-product"]');
  const buyButton = document.getElementById("add-bundle-to-cart-button");
  const bundleQuantity = document.querySelectorAll('[name="bundle-quantity"')[0];

  let checkedProducts = [];
  let bundlePrice = 0;
  let price = 0;
  
  for (let i = 0; i < bundleProducts.length; i++) {
    if (bundleProducts[i].checked) {
      checkedProducts.push(bundleProducts[i].dataset.productId);

      price = parseFloat(bundleProducts[i].dataset.productPrice.replace(",","."));
      bundlePrice += price;
      bundleQuantity.setAttribute("value", checkedProducts.length);
    }
  }

  if (checkedProducts.length == 0) {
    buyButton.setAttribute('disabled', '');
  } else {
    buyButton.removeAttribute('disabled');
  }
  
  buyButton.setAttribute('data-selected-products', checkedProducts);
  buyButton.innerHTML = '€ ' + bundlePrice.toFixed(2).replace(".",",") + ' ' + buyButton.getAttribute('data-add-text');

  const bundleProductsMobile = document.querySelectorAll('[data-product-bundle-mobile="bundle-product-mobile"]');
  const buyButtonMobile = document.getElementById("add-bundle-to-cart-button-mobile");
  const bundleQuantityMobile = document.querySelectorAll('[name-mobile="bundle-quantity-mobile"')[0];

  let checkedProductsMobile = [];
  let bundlePriceMobile = 0;
  let priceMobile = 0;

  for (let i = 0; i < bundleProductsMobile.length; i++) {
    if (bundleProductsMobile[i].checked) {
      checkedProductsMobile.push(bundleProductsMobile[i].dataset.productId);

      priceMobile = parseFloat(bundleProductsMobile[i].dataset.productPrice.replace(",","."));
      bundlePriceMobile += priceMobile;
      bundleQuantityMobile.setAttribute("value", checkedProductsMobile.length);
    }
  }

  if (checkedProductsMobile.length == 0) {
    buyButtonMobile.setAttribute('disabled', '');
  } else {
    buyButtonMobile.removeAttribute('disabled');
  }
  
  buyButtonMobile.setAttribute('data-selected-products', checkedProductsMobile);
  buyButtonMobile.innerHTML = '€ ' + bundlePriceMobile.toFixed(2).replace(".",",") + ' ' + buyButtonMobile.getAttribute('data-add-text');
}


/***********************************************************/
/*---------------------- GAMIFICATION ---------------------*/
/***********************************************************/

function showSnowmen() {
  sessionStorage.setItem("snowman", 0);

  const main_position = document.getElementsByClassName('section');
  const section_header = document.getElementsByClassName('section__header');
  const footer = document.getElementsByClassName('footer__block-list');

  main_position[0].innerHTML += `<div class="snowman" onclick="setSnowman('first-snowman')" id="first-snowman">☃️</div>`;
  section_header[1].innerHTML += `<div class="second-snowman" onclick="setSnowman('second-snowman')" id="second-snowman">☃️</div>`;
  
  footer[0].innerHTML += `<div class="third-snowman" onclick="setSnowman('third-snowman')" id="third-snowman">☃️</div>`;
}

function setSnowman(snowmanName) {
  document.getElementById(snowmanName).style.display = 'none';

  const slideout = document.getElementById('snowman-notify');

  let snowmen_found = sessionStorage.getItem('snowman');

  snowmen_found++;

  sessionStorage.setItem('snowman', snowmen_found);

  if (sessionStorage.getItem('snowman') < 3) {
    slideout.classList.toggle('visible');
    slideout.innerHTML = `<span style='font-size: 30px; padding-right: 20px;'>❄️</span> Good job! You just found ${snowmen_found}/3 snowmen! <span style='font-size: 30px; padding-left: 20px;'>❄️</span>`
    
    setTimeout(() => {
      slideout.classList.toggle('visible');
    }, "3000")
  } else {
    document.getElementById('snowman-modal').style.display = 'block';
    document.getElementById('snowman-modal-container').style.display = 'block';
  }
}

function closeSnowmanModal() {
  document.getElementById('snowman-modal').style.display = 'none';
  document.getElementById('snowman-modal-container').style.display = 'none';
}


/***********************************************************/
/*---------------------- REVIEWS ---------------------*/
/***********************************************************/

function showReviews() {
  const reviews = document.getElementsByClassName("featured_product_reviews");
  const mobile_reviews_container = document.getElementsByClassName("mobile_review_container");
  const desktop_reviews_container = document.getElementsByClassName("desktop_review_container");

  console.log(reviews);
  
  if (window.outerWidth <= 641) {
    for (let i = 0; i < reviews.length; i++) {
      mobile_reviews_container[i].appendChild(reviews[i]);
    }
  } else {
    for (let i = 0; i < reviews.length; i++) {
      desktop_reviews_container[i].appendChild(reviews[i]);
    }
  }
}


/***********************************************************/
/*---------------------- COOKIES ---------------------*/
/***********************************************************/
function acceptCookies() {
  localStorage.setItem("Cookie", "Accepted");
  document.getElementById("cookie-banner").style.display = "none";
}

function showCookies() {
  document.getElementById("cookie-banner").style.display = "block";
}



/***********************************************************/
/*---------------------- CART UPSELL ----------------------*/
/***********************************************************/
function checkCartUpsell() {
  const cart_contents = fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(data => { 
    return data 
  });

  const get_cart_total = () => {
    cart_contents.then((data) => {
      let cart_total = data.total_price / 100;
      const missing_amount_container = document.getElementById("missing-amount");
      const gift_product_name = document.getElementById("gift-product-name");
      const cart_progress_bar = document.getElementById("cart-progress-bar-inner");

      if (data.total_price != 0) {
        if (cart_total < first_gift_price) {
          let missing_amount = first_gift_price - cart_total;

          if (first_gift_product.length == 0) {
            document.getElementById("cart-progress-text").innerHTML = "You are <strong>" + missing_amount.toFixed(2) + "€</strong> away from <strong>FREE SHIPPING</strong>";
          } else {
            missing_amount_container.innerHTML = missing_amount.toFixed(2) + "€";
            gift_product_name.innerHTML = first_gift_product;
          }

          cart_progress_bar.style.width = "0%";

        } else if (cart_total >= first_gift_price && cart_total < second_gift_price) {
          let missing_amount = second_gift_price - cart_total;

          if (second_gift_product.length == 0) {
            document.getElementById("cart-progress-text").innerHTML = "You are <strong>" + missing_amount.toFixed(2) + "€</strong> away from <strong>FREE SHIPPING</strong>";
          } else {
            missing_amount_container.innerHTML = missing_amount.toFixed(2) + "€";
            gift_product_name.innerHTML = second_gift_product;
          }

          cart_progress_bar.style.width = "25%";

          document.getElementById("first-gift").style.borderColor = "#42c0ff";

        } else if (cart_total >= second_gift_price && cart_total < third_gift_price) {
          let missing_amount = third_gift_price - cart_total;

          if (third_gift_product.length == 0) {
            document.getElementById("cart-progress-text").innerHTML = "You are <strong>" + missing_amount.toFixed(2) + "€</strong> away from <strong>FREE SHIPPING</strong>";
          } else {
            missing_amount_container.innerHTML = missing_amount.toFixed(2) + "€";
            gift_product_name.innerHTML = third_gift_product;
          }
          
          cart_progress_bar.style.width = "50%";

          document.getElementById("first-gift").style.borderColor = "#42c0ff";
          document.getElementById("second-gift").style.borderColor = "#42c0ff";

        } else if (cart_total >= third_gift_price && cart_total < fourth_gift_price) {
          let missing_amount = fourth_gift_price - cart_total;

          if (fourth_gift_product.length == 0) {
            document.getElementById("cart-progress-text").innerHTML = "You are <strong>" + missing_amount.toFixed(2) + "€</strong> away from <strong>FREE SHIPPING</strong>";
          } else {
            missing_amount_container.innerHTML = missing_amount.toFixed(2) + "€";
            gift_product_name.innerHTML = fourth_gift_product;
          }

          cart_progress_bar.style.width = "75%";

          document.getElementById("first-gift").style.borderColor = "#42c0ff";
          document.getElementById("second-gift").style.borderColor = "#42c0ff";
          document.getElementById("third-gift").style.borderColor = "#42c0ff";

        } else if (cart_total >= fourth_gift_price) {
          cart_progress_bar.style.width = "100%";
          document.getElementById("cart-progress-text").style.display = "none";
          
          document.getElementById("first-gift").style.borderColor = "#42c0ff";
          document.getElementById("second-gift").style.borderColor = "#42c0ff";
          document.getElementById("third-gift").style.borderColor = "#42c0ff";
          document.getElementById("fourth-gift").style.borderColor = "#42c0ff";
        }
      }
    });
  };
  
  if (show_cart_upsell) {
    get_cart_total();
  }
}

function addToCartUpsell(event, productId, sku) {
  if (sessionStorage.getItem("giftProducts")) {
    let productsArray = [];
    let giftProducts = sessionStorage.getItem("giftProducts");
    
    if (! giftProducts.includes(sku)) {
      productsArray.push(giftProducts);
      productsArray.push(sku);

      sessionStorage.setItem("giftProducts", productsArray);
    }
  } else {
    sessionStorage.setItem("giftProducts", sku);
  }

  let target = event.target;

  target.setAttribute('disabled', 'disabled');
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  let formData = {
    'items': [{
      quantity: 1,
      id: productId
    }]
  };

  fetch("".concat(window.routes.cartAddUrl, ".js"), {
  body: JSON.stringify(formData),
  credentials: 'same-origin',
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

  }
  }).then(function (response) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));

    if (response.ok) {
      target.removeAttribute('disabled');

      document.getElementById("mini-cart").dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: null,
          quantity: 1
        }
      }));

      $( ".header__cart-icon" ).load(window.location.href + " .header__cart-icon>*","" );

      document.getElementById('cart-added-message').style.display = "block";
      setTimeout(() => {
        document.getElementById("cart-added-message").style.display = "none";
      }, 3000);

      let previousButtonValue = event.target.innerHTML;
      event.target.innerHTML = window.languages.productAddedShort;
      setTimeout(function () {
        event.target.innerHTML = previousButtonValue;
      }, 1500);

      return response.json();
    } else {
      response.json().then(function (content) {
        console.log(content['description'], 'error', content);
      });
    }
  });
}

function setContainer() {
  container_upsell = document.getElementById("cart-upsell-products-scroll-id");
}

let max_width_desktop = 0;
let max_width_mobile = 0;

function scrollPrevUpsell() {
  let scroll_upsell_item_width = document.getElementById("cart-upsell-products-scroll-id").getBoundingClientRect().width;

  let number_of_blocks = parseInt(document.getElementsByClassName("cart-upsell-product").length);

  max_width_desktop = (number_of_blocks - 1) * scroll_upsell_item_width;
  max_width_mobile = (number_of_blocks - 1) * scroll_upsell_item_width;

  if (translateUpsell== 0 && window.screen.width > 768) {
    translateUpsell-= max_width_desktop;
    container_upsell.style.transform = "translateX(" + (translateUpsell) + "px)";
  } 
  else if (translateUpsell== 0 && window.screen.width <=768) {
    translateUpsell-= max_width_mobile;
    container_upsell.style.transform = "translateX(" + (translateUpsell) + "px)";
  }  
  else {
    translateUpsell+= scroll_upsell_item_width;
    container_upsell.style.transform = "translateX(" + translateUpsell+ "px)";
  } 
}

function scrollNextUpsell() {
  let scroll_upsell_item_width = document.getElementById("cart-upsell-products-scroll-id").getBoundingClientRect().width;

  let number_of_blocks = parseInt(document.getElementsByClassName("cart-upsell-product").length);
  max_width_desktop = (number_of_blocks - 1) * scroll_upsell_item_width;
  max_width_mobile = (number_of_blocks - 1) * scroll_upsell_item_width;
  
  if (translateUpsell > -max_width_desktop && window.screen.width > 768) {
    translateUpsell -= scroll_upsell_item_width;
    container_upsell.style.transform = "translateX(" + translateUpsell + "px)";
  }
  else if (translateUpsell > -max_width_mobile && window.screen.width <= 768) {
    translateUpsell -= scroll_upsell_item_width;
    container_upsell.style.transform = "translateX(" + translateUpsell + "px)";
  }
  else {
    translateUpsell = 0;
    container_upsell.style.transform = "translateX(" + translateUpsell + "px)";
  }
}




/***********************************************************/
/*----------------- SEARCH RESULTS SCROLL -----------------*/
/***********************************************************/
let translate5 = 0;

function reportWindowSize() {
  scroll_item_width = document.getElementById("blog-list-article-2").getBoundingClientRect().width + 15;
}

function scroll_prev_search(containerId, buttonId) {
  let scroll_item_width = document.getElementById("blog-list-article-2").getBoundingClientRect().width + 15;

  let container = document.getElementById(containerId);

  if (translate5 != 0) {
    translate5 += scroll_item_width;
    container.style.transform = "translateX(" + translate5 + "px" + ")";
    if (translate5 == 0) {
      document.getElementById(buttonId).style.display = "none";
    }
  }
}

function scroll_next_search(containerId, numberOfArticles, buttonId) {
  let scroll_item_width = document.getElementById("blog-list-article-2").getBoundingClientRect().width + 15;

  let container = document.getElementById(containerId);
  let max_width_desktop = (numberOfArticles - 3) * scroll_item_width;
  let max_width_mobile = (numberOfArticles) * scroll_item_width;

  if (translate5 > -max_width_desktop && window.screen.width > 768) {
    translate5 -= scroll_item_width;
    container.style.transform = "translateX(" + translate5 + "px" + ")";
    document.getElementById(buttonId).style.display = "flex";
  }
  else if (translate5 > -max_width_mobile && window.screen.width <= 768) {
    translate5 -= scroll_item_width;
    container.style.transform = "translateX(" + translate5 + "px" + ")";
    document.getElementById(buttonId).style.display = "flex";
  }
  else {
    translate5 = 0;
    container.style.transform = "translateX(" + translate5 + "px" + ")";
    document.getElementById(buttonId).style.display = "none";
  }
}



/***********************************************************/
/*----------------- CHECK IF UPSELL IN CART -----------------*/
/***********************************************************/
function checkCartItems() {
  if (sessionStorage.getItem("giftProducts")) {
    let cartItems = [];
    let sessionItems = sessionStorage.getItem("giftProducts").split(',');
    let itemsInSessionAndCart = [];

    var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => { data.items.forEach(function (product) {
        cartItems.push(product.sku)
      });
    }).then(() => {
      for (let i = 0; i < cartItems.length; i ++) {
        for (let j = 0; j < sessionItems.length; j ++) {
          if (cartItems[i] == sessionItems[j]) {
            itemsInSessionAndCart.push(sessionItems[j]);
          }
        }
      }
    }).then(() => {
      if(document.getElementById("giftProductsInCart")) {
        document.getElementById("giftProductsInCart").value = itemsInSessionAndCart;
      }
    })
   
  }
}